import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-page-tiny-loader',
  templateUrl: './page-tiny-loader.component.html',
  styleUrls: ['./page-tiny-loader.component.css']
})
export class PageTinyLoaderComponent {
  @Output() loaderClosed = new EventEmitter<void>();
  show: boolean = true;

  stopLoader(): void {
    this.loaderClosed.emit();
  }
}
